import { lazy } from 'react';
import { CONTENT_PERMISSIONS } from './constants';

const LegalPage = lazy(() => import('./pages/LegalPage'));
const LandingPage = lazy(() => import('./pages/LandingPage'));
const FooterPage = lazy(() => import('./pages/FooterPage'));

export const contentRoutes = [
  {
    path: '/content/legal',
    element: LegalPage,
    permission: CONTENT_PERMISSIONS.WRITE,
    nav: { labelKey: 'nav.legal', icon: 'FileProtectOutlined', group: 'content' },
  },
  {
    path: '/content/landing',
    element: LandingPage,
    permission: CONTENT_PERMISSIONS.WRITE,
    nav: { labelKey: 'nav.landing', icon: 'PictureOutlined', group: 'content' },
  },
  {
    path: '/content/footer',
    element: FooterPage,
    permission: CONTENT_PERMISSIONS.WRITE,
    nav: { labelKey: 'nav.footer', icon: 'LinkOutlined', group: 'content' },
  },
];
